import { gql } from "@apollo/client";

export const GET_MY_PROFILE = gql`
  query me {
    me {
      objectId
      name
      email
      designation
      memberInfo {
        objectId
      }
    }
  }
`;
export const GET_ALL_COUNTRIES = gql`
  query countries($offset: Int, $first: Int) {
    countries(offset: $offset, first: $first) {
      edges {
        node {
          name
          flag
          key
          objectId
        }
      }
    }
  }
`;
